const freeTextMapping = (data) => {

    const mappedData = {};


    mappedData.title = data.field_component_title[0]?.value;
    mappedData.paragraphsFirstColumn = data.field_body_column_1[0]?.value;
    mappedData.paragraphsSecondColumn = data.field_body_column_2[0]?.value;
    mappedData.ctas = data.field_component_cta[0]  ? [
        {
            title: data.field_component_cta[0]?.title || '',
            alt: data.field_component_cta[0]?.options.attributes['aria-label'] || '',
            href: data.field_component_cta[0]?.url || '/',
            ariaLabel: data.field_component_cta[0]?.options.attributes['aria-label'] || ''
        }
    ] : [];

    return mappedData;

};


export default freeTextMapping;
